/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_License_Bullet_RepositoryInputs */

const en_marketing_license_bullet_repository = /** @type {(inputs: Marketing_License_Bullet_RepositoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The complete repository, every package`)
};

const es_marketing_license_bullet_repository = /** @type {(inputs: Marketing_License_Bullet_RepositoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El repositorio completo, todos los paquetes`)
};

const fr_marketing_license_bullet_repository = /** @type {(inputs: Marketing_License_Bullet_RepositoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le dépôt complet, tous les paquets`)
};

/**
* | output |
* | --- |
* | "The complete repository, every package" |
*
* @param {Marketing_License_Bullet_RepositoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_license_bullet_repository = /** @type {((inputs?: Marketing_License_Bullet_RepositoryInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_License_Bullet_RepositoryInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_license_bullet_repository(inputs)
	if (locale === "es") return es_marketing_license_bullet_repository(inputs)
	return fr_marketing_license_bullet_repository(inputs)
});